var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { reset } from '../styles';
import { toggleStyles } from '../toggle-styles';
/**
 * Dead toggle can be used where the appearance of a checkbox or radio is needed - but for accessibility purposes an actual input element should not be present.
 *
 * [See Storybook for usage examples](https://warp-ds.github.io/elements/?path=/docs/forms-dead-toggle--docs)
 */
export class WarpDeadToggle extends LitElement {
    constructor() {
        super(...arguments);
        this.type = 'radio';
        this.checked = false;
        this.indeterminate = false;
        this.invalid = false;
        this.disabled = false;
    }
    /** @internal */
    get indeterminateMarker() {
        return !this.checked && this.indeterminate ? '–' : '';
    }
    render() {
        return html ` <div class="control">${this.indeterminateMarker}</div> `;
    }
    static { this.styles = [reset, toggleStyles]; }
}
__decorate([
    property({ type: String, reflect: true })
], WarpDeadToggle.prototype, "type", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], WarpDeadToggle.prototype, "checked", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], WarpDeadToggle.prototype, "indeterminate", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], WarpDeadToggle.prototype, "invalid", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], WarpDeadToggle.prototype, "disabled", void 0);
if (!customElements.get('w-dead-toggle')) {
    customElements.define('w-dead-toggle', WarpDeadToggle);
}
//# sourceMappingURL=index.js.map